import type { BulkAccessScope, BulkAccessTarget } from '../types/AccessControl';

export function countTargetsByType(targets: BulkAccessTarget[]): {
  documentCount: number;
  folderCount: number;
} {
  let folderCount = 0;
  let documentCount = 0;

  for (const target of targets) {
    if (target.type === 'folder') {
      folderCount += 1;
    } else {
      documentCount += 1;
    }
  }

  return { documentCount, folderCount };
}

export function getBulkAccessScopeFromCounts({
  documentCount,
  folderCount,
}: {
  documentCount: number;
  folderCount: number;
}): BulkAccessScope {
  if (folderCount > 0 && documentCount > 0) {
    return 'both';
  }
  if (folderCount > 0) {
    return 'folders';
  }
  return 'documents';
}

export function getDefaultBulkAccessScope(
  targets: BulkAccessTarget[],
): BulkAccessScope {
  return getBulkAccessScopeFromCounts(countTargetsByType(targets));
}

export function filterTargetsByScope(
  targets: BulkAccessTarget[],
  scope: BulkAccessScope,
): BulkAccessTarget[] {
  if (scope === 'both') {
    return targets;
  }
  if (scope === 'folders') {
    return targets.filter((target) => target.type === 'folder');
  }
  return targets.filter((target) => target.type === 'document');
}
